// ============================================================================
// ACTIVITY API - Log de actividad de una tarea (endpoint task_activity)
// ============================================================================
// Alimenta las pestañas "Actividad" y "Todo" del detalle. Fetch autenticado con
// el mismo patrón que el resto de servicios (Bearer del localStorage sobre
// window.__APP_CONFIG__.API_URL). Aislado por diseño: cualquier fallo se
// devuelve como { success:false } y NUNCA rompe la pestaña de Comentarios, que
// se sirve por su propia vía (CommentService).
// ============================================================================

import apiClient from './apiClient';

/**
 * Devuelve el log de actividad de una tarea, más reciente primero.
 *
 * @param {string} taskId  id interno de la tarea (task-YYYYMMDD-hash) o su ref.
 * @returns {Promise<{success:boolean, data:Array, error?:string}>}
 *   data = [{ usuario_nombre, usuario_avatar, accion,
 *             datos_anteriores, datos_nuevos, fecha_accion }]
 */
export async function getTaskActivity(taskId) {
  if (!taskId) {
    return { success: false, data: [], error: 'ID de tarea requerido' };
  }

  try {
    // El apiClient deriva la base por tenant, pone el Bearer y lanza en !ok
    // (recogido por el catch → { success:false }, aislado como antes).
    const result = await apiClient.get('task_activity', { id: taskId });
    if (result.status === 'success') {
      return { success: true, data: Array.isArray(result.data) ? result.data : [] };
    }
    return {
      success: false,
      data: [],
      error: result.message || 'Error al cargar la actividad',
    };
  } catch (error) {
    return { success: false, data: [], error: `Error de conexión: ${error.message}` };
  }
}

const activityApi = { getTaskActivity };
export default activityApi;
